import { Component } from '@angular/core';
import { NavController, NavParams, Content } from 'ionic-angular';
import { TakeawayServices } from "../services";
import { AfterViewChecked, ViewChild, OnInit } from '@angular/core';
import { Globals } from '../../../globals';

/**
 * Generated class for the TpvRoomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-orders',
  templateUrl: 'takeaway-orders.html',
})
export class TakeawayOrdersPage implements OnInit, AfterViewChecked {
  @ViewChild('scrollMe') private content: Content;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,) {
    this.globals.GAtrackView('TakeAway', 'TakeAway - List', this.globals.restaurant.email, 'View', 'List takeaway', 'TakeAway', '');

  }

  ngOnInit() {
    this.scrollToBottom();
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    this.content.scrollToBottom(0);
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-orders/takeaway-orders.ts